import { Form, Select } from 'antd';
import React, { useMemo } from 'react';
import { useRawAttributes } from '../../../../../utils/zustand';

const GetAttribute = ({ value, onChange, fieldNamePrefix = [] }) => {
  const { rawAttributes } = useRawAttributes();

  // Group attributes by type for Select optgroup
  const groupedOptions = useMemo(() => {
    if (!rawAttributes || rawAttributes.length === 0) return [];

    const groups = rawAttributes.reduce((acc, attr) => {
      const { type, typeLabel } = attr;
      if (!acc[type]) {
        acc[type] = { label: typeLabel, options: [] };
      }
      acc[type].options.push({
        label: `${attr.label} (${attr.name})`,
        value: attr.name,
      });
      return acc;
    }, {});

    // Return groups in order: structured, technical, marketing
    const order = ['structured', 'technical', 'marketing'];
    return order.filter((key) => groups[key]).map((key) => groups[key]);
  }, [rawAttributes]);

  return (
    <Form.Item
      label="Sélectionner un attribut"
      name={[...fieldNamePrefix, 'attr']}
      rules={[{ required: true, message: 'Veuillez sélectionner un attribut' }]}
      initialValue={value}
    >
      <Select
        placeholder="Choisissez un attribut"
        showSearch
        optionFilterProp="label"
        options={groupedOptions}
        style={{ width: '100%' }}
        onChange={(val) => onChange(val)}
      />
    </Form.Item>
  );
};

export default GetAttribute;
